module.exports = __webpack_public_path__ + "static/media/r264.bc68ea20.jpg";